export default __webpack_public_path__ + "static/media/streamlit-book.0329c569.png";